export const CUSTOMIZATIONS_DATA_GRABS = {
    textFieldWrapperDataGrab: 'product-customizations-text-field',
    labelDataGrab: 'product-customizations-label',
    textAreaDataGrab: 'product-customizations-text-field-textarea',
    textAreaPlaceholderDataGrab:
        'product-customizations-text-field-placeholder',
    counterDataGrab: 'product-customizations-text-field-counter',
    checkboxWrapperDataGrab: 'product-customizations-checkbox-wrapper',
    fileWrapperDataGrab: 'product-customizations-file-wrapper',
    fileUploadDataGrab: 'product-customizations-file-upload',
    choicesContainerDataGrab: 'product-customizations-choices-container',
    choiceLabelDataGrab: 'product-customizations-choice-label',
    choiceDataGrab: 'product-customizations-choice',
    choiceCheckedDataGrab: 'product-customizations-choice-checked',
    paidAddonTextDataGrab: 'product-customizations-paid-addon-text',
    choiceQuantityStepperDataGrab:
        'product-customizations-choice-quantity-stepper',
    choiceQuantityValueDataGrab: 'product-customizations-choice-quantity-value',
    choiceQuantityButtonDataGrab:
        'product-customizations-choice-quantity-button',
};

export const MAX_TEXT_FIELD_LENGTH = 320;
